import { FieldControllerTypes, FieldTypes } from '../../../components/form_v2/types';
import { useTranslation } from 'react-i18next';

export const communicationFields = () => {
  const { t } = useTranslation();
  return [
    [{
      control: FieldControllerTypes.input,
      type: FieldTypes.text,
      label: t('Όνομα'),
      name: 'first_name',
      required: true,
    },
    {
      control: FieldControllerTypes.input,
      type: FieldTypes.text,
      label: t('Επώνυμο'),
      name: 'last_name',
      required: true,
    }],
    [{
      control: FieldControllerTypes.input,
      type: FieldTypes.text,
      label: 'Email',
      name: 'email',
      required: true,
    },
    {
      control: FieldControllerTypes.telInput,
      type: FieldTypes.text,
      label: t('Τηλέφωνο'),
      name: 'phone',
      required: true,
    }],
    [{
      control: FieldControllerTypes.input,
      type: FieldTypes.text,
      label: t('Επωνυμία Επιχείρησης'),
      name: 'co_name',
    }],
    [{
      control: FieldControllerTypes.textarea,
      type: FieldTypes.text,
      name: 'descr_co',
      label: t('Περιγραφή Συνεργασίας'),
      required: true,
    }],
    [{
      control: FieldControllerTypes.checkboxTerms,
      type: FieldTypes.checkboxTerms,
      label: t('Αποδοχή όρων Χρήσης & Ορθότητας Στοιχείων'),
      name: 'termsAndConditions',
      required: true,
      link: true
    }]
  ];
};